
function HomeSection1() {
    return (
        <section class="main-container"> 
          <img src={require('../images/mvp.heropng.png')} />
       </section>
    )
}

export default HomeSection1;